import React, { memo } from 'react';
import { CloseIcon, ExpandIcon } from './Icons';
import { BUTTON_THEMES } from '../config/themes';

const ExpandButton = memo(({ panelId, isExpanded, onToggle, theme = 'default' }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onToggle(panelId);
  };

  const currentTheme = BUTTON_THEMES[theme] || BUTTON_THEMES.default;

  return (
    <button
      onClick={handleClick}
      className={`absolute top-1/2 right-2 -translate-y-1/2 p-1.5 rounded transition-all ${currentTheme.bg} ${currentTheme.text} border ${currentTheme.border} active:scale-90`}
    >
      {isExpanded ? <CloseIcon /> : <ExpandIcon />}
    </button>
  );
});

ExpandButton.displayName = 'ExpandButton';

export default ExpandButton;